export const MAX_PAGINATION_SIZE = 100;

export const DEFAULT_PAGE_SIZE = 50;
